var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-secondary-pages"},[_c('div',{staticClass:"yellow"}),_c('div',{staticClass:"rose"}),_c('div',{staticClass:"yellow-sec"}),_c('div',{staticClass:"white"})])
}]

export { render, staticRenderFns }